import { z } from "zod";
import {
  NotificationChatroomKindEnum,
  NotificationEventTypeEnum,
  NotificationKindEnum,
  NotificationMetadataSchema,
} from "./common";

export const ConvexNotificationCreateRequestSchema = z.object({
  kind: NotificationKindEnum,
  event_type: NotificationEventTypeEnum,
  title: z.string().min(1),
  body: z.string().min(1),
  deep_link: z.string().min(1),
  metadata: NotificationMetadataSchema,
  recipient_org_ids: z.array(z.number().int().positive()).min(1),
  send_email: z.boolean().optional(),
  project_id: z.number().int().positive().optional(),
  lead_id: z.number().int().positive().optional(),
  lead_match_id: z.number().int().positive().optional(),
  thread_id: z.string().optional(),
  chatroom_kind: NotificationChatroomKindEnum.optional(),
  message_id: z.string().optional(),
  source_event_id: z.string().optional(),
  sender_org_id: z.number().int().positive().optional(),
  sender_user_id: z.number().int().positive().optional(),
  occurred_at: z.number().int().nonnegative().optional(),
});
export type ConvexNotificationCreateRequest = z.infer<typeof ConvexNotificationCreateRequestSchema>;

export const NotificationEmailDispatchRequestSchema = z.object({
  notification_id: z.string(),
  notification_recipient_id: z.string(),
  kind: NotificationKindEnum,
  event_type: NotificationEventTypeEnum,
  title: z.string().min(1),
  body: z.string().min(1),
  deep_link: z.string().min(1),
  org_id: z.number().int().positive(),
  project_id: z.number().int().positive().optional(),
  lead_id: z.number().int().positive().optional(),
  lead_match_id: z.number().int().positive().optional(),
  thread_id: z.string().optional(),
  chatroom_kind: NotificationChatroomKindEnum.optional(),
  message_id: z.string().optional(),
  source_event_id: z.string().optional(),
  sender_org_id: z.number().int().positive().optional(),
  sender_user_id: z.number().int().positive().optional(),
  metadata: NotificationMetadataSchema,
  occurred_at: z.string().datetime(),
  created_at: z.string().datetime(),
});
export type NotificationEmailDispatchRequest = z.infer<typeof NotificationEmailDispatchRequestSchema>;
